import React from "react";

export const InvoiceUploadExplanation = () => {
  return(
    <section className="cardSection _noBorder _noBottomPadding">
      <p className="preamble">Step 1 of 2</p>
      <h2 className="subhead">Upload an active Invoice for financing</h2>
      <ul className="listText _marginTop--normal">
        <li>Please upload one Invoice at a time</li>
        <li>Please upload all pages of that single Invoice</li>
        <li>The following document types are accepted as Invoice:
          <ul className="listText">
            <li>Sales Invoice, Charge Invoice, Delivery Receipt, Counter Receipt, Billing Statement</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>Must be clear and readable</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>The document should contain the following details: Invoice number, Amount of the Transaction, Issued Date, Payment Terms</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>The transaction should not be paid yet</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>The documents should be stamped/signed as "received" by each respective buyer</li>
          </ul>
        </li>
      </ul>
    </section>
  );
}

export const PurchaseOrderUploadExplanation = () => {
  return(
    <section className="cardSection _noBorder _noBottomPadding">
      <p className="preamble">Step 1 of 2</p>
      <h2 className="subhead">Upload an active Purchase Order for financing</h2>
      <ul className="listText _marginTop--normal">
        <li>Please upload one Purchase Order at a time</li>
        <li>Please upload all pages of that single Purchase Order</li>
        <li>The following document types are accepted as Purchase Order:
          <ul className="listText">
            <li>Notice of Award, Notice to Proceed, Work Order, Job Order</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>Must be clear and readable</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>The document should contain the following details: Purchase Order number, delivery Terms/delivery Date, payment terms</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>Items or services should not be delivered yet</li>
            <li className="note"><i className="materialIcon --micro -success">done</i>Transaction should not be paid yet</li>
          </ul>
        </li>
      </ul>
    </section>
  );
}




// WEBPACK FOOTER //
// ./src/features/trade_documents/components/TradeDocumentExplanation.js